// extracted by mini-css-extract-plugin
export default {"appBar":"appBar-wL9C1B"};